import { NhostClient } from '@nhost/react';

// const nhost = new NhostClient({
// backendUrl: 'http://192.168.0.102:1337',

// backendUrl: process.env.REACT_APP_NHOST_BACKEND_URL,
// subdomain: process.env.REACT_APP_NHOST_SUBDOMAIN,
// region: process.env.REACT_APP_NHOST_REGION,
// subdomain: 'localhost',
// backendUrl: 'https://local.hasura.nhost.run/v1/graphql',
// subdomain: 'lfeqzoprknjffkoryrrq',
// region: 'ap-south-1',
// autoSignIn: true,
// autoRefreshToken: true,
// });

// const nhost = new NhostClient(
//   {
//     region: 'local', subdomain: '192-168-1-120', autoSignIn: true,
//     autoRefreshToken: true,
//   }
//

const nhost = new NhostClient({
  subdomain: process.env.REACT_APP_NHOST_SUBDOMAIN,
  region: process.env.REACT_APP_NHOST_REGION,
  autoSignIn: true,
  autoRefreshToken: true,
});

export { nhost };
